<div class="contentHeight form noPrint dynamicBottom">
  <h1 class="titleContretypage">

    Contretypage N° {{ colorMatching.reference }}

    <button *ngIf="Utils.isAxalta(role) && colorMatching.response != undefined && compareDate(colorMatching.dateFinish)" class="btn btn-secondary exportationBtn" (click)="generateXMLFormule(colorMatching)" download="file.xml">
      <i  aria-hidden="true" class="far fa-file-export fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" matTooltip="{{ 'contretypage.exportContretypage' | translate}}"></i>
    </button>
    <button *ngIf="Utils.isAxalta(role) && colorMatching.response != undefined && compareDate(colorMatching.dateFinish)" class="btn btn-secondary exportationBtn" (click)="copierContretypage(colorMatching)">
      <i  aria-hidden="true" class="far fa-copy fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" matTooltip="{{ 'contretypage.copieFormule' | translate}}"></i>
    </button>
    <button *ngIf="Utils.isAxalta(role) && compareDate(colorMatching.dateCreate) && colorMatching.response == undefined && copyPasteContretypage" class="btn btn-secondary exportationBtn" (click)="collerContretypage(colorMatching)">
      <i  aria-hidden="true" class="far fa-paste fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" matTooltip="{{ 'contretypage.colleFormule' | translate}}"></i>
    </button>
    <button *ngIf="!Utils.isAxalta(role) || compareDate(colorMatching.dateFinish) || (compareDate(colorMatching.dateCreate) && !compareDate(colorMatching.dateReceive) && !compareDate(colorMatching.dateFinish))" class="btn btn-secondary exportationBtn" (click)="print()">
      <i  aria-hidden="true" class="fas fa-print fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" matTooltip="{{ 'contretypage.imprimerMsg' | translate}}"></i>
    </button>
    <!---->
  </h1>

  <mat-horizontal-stepper class="horizontalStepper backgroundWhiteRound" (selectionChange)="changeEditStep($event)">
    <!-- (click)="triggerClick()" -->
    <!-- STEP - Recapitulatif -->
    <mat-step completed="false" label="{{ 'contretypage.titleRecap' | translate}}" state="speaker_notes">
      <div class="recap row">
        <div *ngIf="Utils.isUserIxell(role) || Utils.isCTC(role)" class="col-12 col-md-6 flexColumn mt-3 paddingRightContretypage">
          <div>
            <h3 class="substitle" [translate]="''">{{ 'contretypage.carrossier' | translate}}</h3>
            <hr>
            <div class="col-lg-6">
              {{'scaleform.nom'|translate}} : {{ colorMatching.user_Name }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.prenom'|translate}} : {{ colorMatching.user_Firstname }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.mail'|translate}} : {{ colorMatching.user_Mail }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.mobile'|translate}} : {{ colorMatching.user_Mobile }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.telephone'|translate}} : {{ colorMatching.user_Phone }}
            </div>
          </div>
          <div>
            <h3 class="substitle" [translate]="''">{{ 'contretypage.societe' | translate}}</h3>
            <hr>
            <div class="col-lg-12">
              {{'scaleform.raisonsociale'|translate}} : {{ colorMatching.company_SocialReason }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.adresse'|translate}} : {{ colorMatching.company_Address }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.codepostal'|translate}} : {{ colorMatching.company_PostalCode }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.ville'|translate}} : {{ colorMatching.company_City }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.pays'|translate}} : {{ colorMatching.company_Country }}
            </div>
          </div>
          <div>
            <h3 class="substitle" [translate]="''">{{ 'contretypage.ctc' | translate}}</h3>
            <hr>
            <div class="col-lg-6">
              {{'scaleform.nom'|translate}} : {{ colorMatching.ctC_Name }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.prenom'|translate}} : {{ colorMatching.ctC_Firstname }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.mail'|translate}} : {{ colorMatching.ctC_Mail }}
            </div>
            <div class="col-lg-6">
              {{'scaleform.telephone'|translate}} : {{ colorMatching.ctC_Phone }}
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mt-3 paddingLeftContretypage">
          <div>
            <h3 class="substitle" [translate]="'contretypage.titleVehicule'"></h3>
            <hr>
            <div class="col-lg-4">
              {{'common.manufacturer'|translate}} : <span *ngIf="colorMatching.brandVehicle != ''; then showBrand else notShow"></span>
              <ng-template #showBrand>
                {{ colorMatching.brandVehicle }}
              </ng-template>
            </div>
            <div class="col-lg-4">
              {{'search.model'|translate}} : <span *ngIf="colorMatching.modelVehicle != ''; then showModel else notShow"></span>
              <ng-template #showModel>
                {{ colorMatching.modelVehicle }}
              </ng-template>
            </div>
            <div class="col-lg-4">
              {{'search.year'|translate}} : <span *ngIf="(colorMatching.yearVehicle); then showYear else notShow"></span>
              <ng-template #showYear> {{ colorMatching.yearVehicle }}</ng-template>
            </div>
          </div>
          <div>
            <h3 class="substitle" [translate]="'contretypage.titleEltContretype'"></h3>
            <hr>
            <div class="col-lg-12">
              {{'common.designation'|translate}} : <span *ngIf="colorMatching.designationOriginElement != ''; then showElement else notShow"></span>
              <ng-template #showElement>
                {{ colorMatching.designationOriginElement }}
              </ng-template>
            </div>

          </div>
          <div>
            <h3 class="substitle" [translate]="'contretypage.titleEltPeindre'"></h3>
            <hr>
            <div class="col-lg-12">
              {{'contretypage.teinte'|translate}} : {{ Teinte[colorMatching.colorOriginElement] }}
            </div>
            <div class="col-lg-12">
              {{'common.designation'|translate}} : {{ colorMatching.designationFinalElement }}
            </div>
          </div>
          <div>
            <h3 class="substitle" [translate]="'contretypage.Autres'"></h3>
            <hr>
            <div class="col-lg-6">
              {{ 'contretypage.codepeinture' | translate}} : <span *ngIf="(colorMatching.codePainting != ''); then showCode else notShow"></span>
              <ng-template #showCode> {{ colorMatching.codePainting }}</ng-template>
            </div>
            <div class="col-lg-6">
              {{'contretypage.designation'|translate}} : <span *ngIf="(colorMatching.designationPainting != ''); then showDes else notShow"></span>
              <ng-template #showDes> {{ colorMatching.designationPainting }}</ng-template>
            </div>
            <div class="col-lg-12">
              {{ 'common.technology' | translate}} : {{ techDemande }}<!--{ Technologie[colorMatching.paintQuality] }}-->
              <!--<div *ngIf="(Utils.isAxalta(role) && ((colorMatching.designationOriginElement != '' && compareDate(colorMatching.dateReceive)) || colorMatching.designationOriginElement == '')); else showTech">-->
              <div *ngIf="(Utils.isAxalta(role) && ( (colorMatching.designationOriginElement != '' && compareDate(colorMatching.dateReceive) ) || colorMatching.designationOriginElement == '')) && !compareDate(colorMatching.dateFinish); else showTech">
                <!-- || compareDate(colorMatching.dateFinish) -->

                <form id="technology" [formGroup]="technologyForm">
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'common.technology' | translate }} :</mat-label>
                    <mat-select (selectionChange)="changeTechnologySelected()" [(value)]="paintQuality" formControlName="technology">
                      <!-- [(value)]="colorMatching.paintQuality" -->
                      <mat-option [value]="1">{{ Technologie[1]}}</mat-option>
                      <mat-option [value]="2">{{ Technologie[2]}}</mat-option>
                      <mat-option [value]="3">{{ Technologie[3]}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </form>
              </div>

              <ng-template #showTech>
                <div *ngIf="compareDate(colorMatching.dateFinish)"><mat-label>{{ 'common.technology' | translate }} {{ 'contretypage.reponse' | translate}} :</mat-label> {{ Technologie[paintQuality] }}</div>
              </ng-template>

            </div>
            <div class="col-lg-12">
              {{ 'contretypage.comment' | translate}} : <span *ngIf="(colorMatching.comment != ''); then showComment else notShow"></span>
              <ng-template #showComment> {{ colorMatching.comment }}</ng-template>
            </div>
          </div>
        </div>
        <ng-template #notShow> - </ng-template>
      </div>
    </mat-step>



    <!-- STEP - Formule -->
    <mat-step completed="false" label="{{ 'details.formule' | translate}}" state="invert_colors" *ngIf="(Utils.isAxalta(role) && ((colorMatching.designationOriginElement != '' && compareDate(colorMatching.dateReceive)) || colorMatching.designationOriginElement == '')) || compareDate(colorMatching.dateFinish)" name="resp">

      <div *ngIf="!Utils.isAxalta(role) && compareDate(colorMatching.dateFinish);">
        <button class="zoomQrCodeContretypage QRcode noPrint" (click)="openModal('ModalQrCode')">
          <img class="QRcode-img" src="assets/qr-code.png" alt=""/> <!--QRCODE-->
        </button>
      </div>

      <form class="row mt-3" id="response" [formGroup]="responseCMForm">
        <div *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish); then contenuAxalta else contenuClientAndCTC"></div>
        <ng-template #contenuAxalta>

          <div class="resp col-12">

            <mat-form-field class="col-lg-2">
              <mat-label>{{'common.manufacturer'|translate}}</mat-label>
              <input matInput type="text" formControlName="brandVehicle" autocomplete="off" (ngModelChange)="selectManufacturers($event)" list="manufacturerList"
                     (focusout)="selectCodeFormule($event)" />

              <datalist id="manufacturerList">
                <select>
                  <option *ngFor="let m of manufacturerList" value="{{m}}"></option>
                </select>
              </datalist>

              <!--[matAutocomplete]="brand"-->
              <!--(onSelectionChange)="selectCodeFormule($event)"-->
              <!--<mat-autocomplete #brand="matAutocomplete" class="">
    <mat-option *ngFor="let m of manufacturerList" value="{{m}}">

      <div class="">{{m}}</div>
    </mat-option>
  </mat-autocomplete>-->
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>{{'contretypage.codeForm'|translate}}</mat-label>
              <input matInput type="text" formControlName="codeFormule" autocomplete="off" (ngModelChange)="selectCodeFormule($event)" list="formuleList"
                     (focusout)="selectDesignation($event)" />
              <!--(click)="selectCodeFormule($event)"-->

              <datalist id="formuleList">
                <select>
                  <option *ngFor="let f of formuleList" value="{{f}}"></option>
                </select>
              </datalist>

              <!--[matAutocomplete]="formule"
                <mat-autocomplete #formule="matAutocomplete" class="">
                <mat-option *ngFor="let f of formuleList" value="{{f}}">
                  <div class="">{{f}}</div>
                </mat-option>
              </mat-autocomplete>-->
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>{{'contretypage.designation'|translate}}</mat-label>
              <input matInput type="text" formControlName="designationPainting" autocomplete="off" (ngModelChange)="selectDesignation($event)" list="designationList"
                     (focusout)="selectVariantes($event)" />
              <!--(click)="selectDesignation($event)"-->

              <datalist id="designationList">
                <select>
                  <option *ngFor="let d of designationList" value="{{d}}"></option>
                </select>
              </datalist>

              <!--[matAutocomplete]="designation"
                <mat-autocomplete #designation="matAutocomplete" class="">
                <mat-option *ngFor="let d of designationList" value="{{d}}">
                  <div class="">{{d}}</div>
                </mat-option>
              </mat-autocomplete>-->
            </mat-form-field>

            <!--<mat-form-field class="col-lg-2">
              <mat-label>{{'contretypage.variante'|translate}}</mat-label>
              <input matInput type="text" formControlName="variante" autocomplete="off" />
            </mat-form-field>-->

            <mat-form-field class="col-lg-2">
              <mat-label>{{'contretypage.variante'|translate}}</mat-label>
              <input matInput type="text" formControlName="variante" list="varianteList" autocomplete="off" (ngModelChange)="selectVariantes($event);" />

              <!--(click)="selectVariantes($event)"-->

              <datalist id="varianteList">
                <select>
                  <option>{{'contretypage.stepColorMatching'|translate}}</option>
                  <option *ngFor="let v of varianteList" value="{{v}}"></option>
                </select>
              </datalist>

            </mat-form-field>

            <div class="select-coatCd">

              <mat-form-field>
                <!-- class="select-coatCd" -->
                <!--col-lg-2-->
                <!--<mat-label> CoatCd </mat-label>-->
                <mat-select (selectionChange)="changeCoatCdSelected()" [(value)]="currentCoatCd" formControlName="coatCd">
                  <mat-option *ngFor="let coat of lstCoatCdCM" [value]="coat.coatCd">{{coat.coatCd}} - <small>{{coat.coatDesc}}</small></mat-option>
                </mat-select>
              </mat-form-field>

              <!--<div *ngIf="colorMatching.response != undefined && !Utils.isAxalta(role)" class="">
                <i  aria-hidden="true" class="far fa-trash-alt btnIngr fa-2x" (click)="()" matTooltip="{ 'contretypage.delIngr' | translate}}"></i>
                <div style="display: none;">
                  <img class="thumbnail" src="data:image/png;base64,{zoomQrcode}}" alt=""/>
                </div>

              </div>-->
              <!--<div class="select-coatCd-remove">
                <i  aria-hidden="true" class="fas fa-times fa-1x pointer" style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #da2917ed;" matTooltip="{{ 'activlist.fermer' | translate}}" (click)="removeCoat()"></i>
              </div>-->

            </div>

            <div class="col-lg-2 openModal">
              <i  aria-hidden="true" class="far fa-plus-square btnIngr fa-2x5" (click)="openModal('ModalIngredient')" matTooltip="{{ 'contretypage.addIngr' | translate}}"></i>
            </div>
            <!--</div>-->
          </div>

        </ng-template>

        <ng-template #contenuClientAndCTC>
          <div class="resp col-12">

            <div class="col-lg-6 p-0">
              {{'common.manufacturer'|translate}} : {{ responseCM.brandVehicle }}
            </div>
            <div class="col-lg-6 p-0">
              {{ 'contretypage.codeForm' | translate}} : {{ responseCM.codeFormule }}
            </div>
            <div class="col-lg-6 p-0">
              {{ 'contretypage.designation' | translate}} : {{ responseCM.designationPainting }}
            </div>
            <div class="col-lg-6 p-0">
              {{ 'contretypage.variante' | translate}} : {{ responseCM.variante }}
            </div>

          </div>
        </ng-template>

        <div class="col-lg-12">

          <!--<mat-checkbox type="checkbox" formControlName="multi"> multi</mat-checkbox>-->
          <!--<mat-form-field>
            <mat-label>Selected tab index</mat-label>
            <input matInput type="number" [formControl]="selected">
          </mat-form-field>-->
          <!--<div>

            <mat-checkbox #selectAfterAdding> Select tab after adding </mat-checkbox>
          </div>-->

          <mat-tab-group id="response-mat-tab-group" class="response-mat-tab-group" [selectedIndex]="selected.value" (selectedIndexChange)="onTabClick($event)" animationDuration="0ms">
            <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab">


              <div class="col-12 response-container-lstIngrCM">
                <!--<label class="labelAlignement">{{ 'contretypage.ingrForm' | translate}} : </label>
                <div *ngIf="Utils.isAxalta(role)">
                  <i  aria-hidden="true" class="far fa-plus-square btnIngr openModal fa-2x5" (click)="openModalIngredient()" matTooltip="{ 'contretypage.addIngr' | translate}}"></i>
                </div>-->
                <mat-table class="table lstIngrCM table-hover mat-elevation-z8" [(dataSource)]="ingredientArray">

                  <ng-container matColumnDef="drag">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish)" class="upDownIng">
                        <i  aria-hidden="true" class="far fa-2x fa-chevron-square-up d-block orderIng" (click)="upIng(element)"></i>
                        <i  aria-hidden="true" class="far fa-2x fa-chevron-square-down d-block orderIng" (click)="downIng(element)"></i>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <!-- Position Column -->
                  <ng-container matColumnDef="position">
                    <mat-header-cell *matHeaderCellDef> {{ 'contretypage.numero' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">  {{ element.position }} </mat-cell>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="code">
                    <mat-header-cell *matHeaderCellDef> {{ 'details.code' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{ element.code }} </mat-cell>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef> {{ 'common.designation' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
                  </ng-container>

                  <!-- Quantité pour la formule Column -->
                  <ng-container matColumnDef="quantity">
                    <mat-header-cell *matHeaderCellDef> {{ 'contretypage.qte' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish); else disableUpdateQtyProd">
                        <input type="number" max="99999.9" min="0.1" step="0.1" value="{{ element.quantity }}" (change)="changeQty(element)" id="qty-{{ element.bnum }}" />
                      </div>
                      <ng-template #disableUpdateQtyProd>
                        {{ element.quantity }}
                      </ng-template>
                    </mat-cell>
                  </ng-container>

                  <!-- Quantité cumulé des ingrédients Column -->
                  <ng-container matColumnDef="qtyCumule">
                    <mat-header-cell *matHeaderCellDef> {{ 'contretypage.cumul' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{ element.qtyCumule }} </mat-cell>
                  </ng-container>

                  <!-- Add or Remove Column -->
                  <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <i  aria-hidden="true" class="far fa-trash-alt btnIngr fa-2x" (click)="deleteIngredient(element)" matTooltip="{{ 'contretypage.delIngr' | translate}}"></i>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;" class="upDownIng-row"></mat-row>
                </mat-table>

              </div>

              <div class="btnStepMultiCouche" *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish);">
                <button *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish);" mat-raised-button class="example-delete-tab-button" [disabled]="tabs.length === 1" (click)="previousTab(index)">{{ 'contretypage.prevCoucheMulti' | translate}}</button>
                <button *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish);" mat-raised-button class="example-add-tab-button" (click)="nextTab(index);">{{ 'contretypage.nextCoucheMulti' | translate}}</button>
              </div>

            </mat-tab>
          </mat-tab-group>

        </div>

      </form>
    </mat-step>

    <!-- STEP - Réponse -->
    <mat-step completed="false" label="{{ 'contretypage.reponse' | translate}}" state="send" *ngIf="(Utils.isAxalta(role) && ((colorMatching.designationOriginElement != '' && compareDate(colorMatching.dateReceive)) || colorMatching.designationOriginElement == '')) || compareDate(colorMatching.dateFinish)" name="resp">
      <form class="row mt-3" id="response2" [formGroup]="responseCMForm">
        <div *ngIf="Utils.isAxalta(role) && !compareDate(colorMatching.dateFinish)" class="col-12">
          <div class="row">
            <div class="col-12 col-md-6">
              <mat-form-field class="col-12">
                <mat-label>{{ 'contretypage.ecartConstate' | translate}} :</mat-label>
                <mat-select [(value)]="legend" formControlName="legend">
                  <mat-option *ngFor="let l of legends" [value]="l.id">{{ l.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-12">
                <textarea matInput formControlName="comment" placeholder="{{ 'contretypage.comment' | translate}}" class="comment" autocomplete="off"></textarea>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field class="col-12">
                <mat-label>{{ 'contretypage.libPhraseTxt' | translate}}</mat-label>
                <mat-select (selectionChange)="changeTextFormInfo($event)" [(value)]="sentences" formControlName="sentences" multiple panelClass="panel-sentences-override">
                  <mat-option *ngFor="let textSentence of lstTextSentencesCM" [value]="textSentence.id">{{ textSentence.text }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-12">
                <textarea matInput formControlName="formuleInfo" placeholder="{{ 'contretypage.infoForm' | translate}}" class="comment formuleInfo" readonly="readonly"></textarea>
              </mat-form-field>
            </div>

            <div class="col-12 RespBtn">
              <button (keydown.enter)="preventEnter($event)" class="btn btn-secondary" (click)="openModal('ModalConfirmEnvoi')">{{ 'contretypage.rep' | translate}}</button>
            </div>
          </div>
        </div>

        <div *ngIf="compareDate(colorMatching.dateFinish)" class="col-12">
          <div class="col-lg-12 p-0">
            {{ 'contretypage.ecart' | translate}} : {{ colorMatching.response.legend }}
          </div>

          <!--<div class="flexRow">-->
          <div class="col-lg-12 p-0">
            {{ 'contretypage.comment' | translate}} : {{ colorMatching.response.comment }}
          </div>
          <div class="col-lg-12 p-0">
            {{ 'contretypage.infoForm' | translate}} :
            <ul class="sentencesImp">
              <!--<li>{ colorMatching.response.formuleInfo }}</li>-->
              <li *ngFor="let textSentence of textSentencesCM">
                {{ textSentence.text }}
              </li>
            </ul>

          </div>
          <div class="legendImp">
            <br />
            <div>{{ 'contretypage.legend' | translate}} :</div>
            <div>
              {{ 'contretypage.leg1' | translate}}
            </div>
            <div>
              {{ 'contretypage.leg2' | translate}}
            </div>
            <div>
              {{ 'contretypage.leg3' | translate}}
            </div>
            <div>
              {{ 'contretypage.leg4' | translate}}
            </div>
            <div>
              {{ 'contretypage.etoile1' | translate}}
            </div>
            <div>
              {{ 'contretypage.etoile2' | translate}}
            </div>
          </div>
        </div>

      </form>

    </mat-step>

    <!-- Icon overrides. -->
    <ng-template matStepperIcon="speaker_notes">
      <mat-icon>speaker_notes</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="invert_colors">
      <mat-icon>invert_colors</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="send">
      <mat-icon>send</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <mat-icon>{{ stepEdit }}</mat-icon>
    </ng-template>

  </mat-horizontal-stepper>

</div>

<!-- Modal de confirmation avant envoi du contretypage -->
<div id="ModalConfirmEnvoi" class="modal">
  <div class="modal-content-confirm">
    <span class="text-right mr-2 pointer close" (click)="closeModal('ModalConfirmEnvoi');">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    <div class="container">
      <div class="upperText">
        <h2 class="text-center">{{'contretypage.envoiReponse'|translate}}</h2> <!--{idContretypage}}</h2>-->
        <strong id="modal-content-confirm-strong-multiCouche">{{'contretypage.warningEnvoiReponse'|translate}}</strong>
      </div>
      <div class="center">
        <button class="btn btn-secondary modal-content-confirm-send" type="button" name="Cancel" value="Cancel" (click)="closeModal('ModalConfirmEnvoi')">
          <span [translate]="'contretypage.annuler'"></span>
        </button>
        <button class="btn btn-secondary modal-content-confirm-cancel" type="button" name="Valider" value="Valider" (click)="sendResponse()">
          <span [translate]="'contretypage.confirmer'"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<div id="ModalIngredient" class="modal noPrint">
  <div class="modal-content">
    <div class="headerModal">
      <h3 class="leftFlex">{{ 'contretypage.addIngr' | translate}}</h3>
      <span class="rightFlex pointer close" (click)="closeModal('ModalIngredient')">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    </div>
    <div>
      <input matInput type="text" id="CodeSearch" value="" (keyup)="searchCodeFormule($event)" placeholder="{{ 'search.searchBtn' | translate}}">
      <div class="row">
        <mat-table class="table lstIngr bg-white table-hover" [dataSource]="ingredientToAddArray">

          <!-- Name Column -->
          <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef> {{ 'details.code' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.code }} </mat-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> {{ 'common.designation' | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- Add or Remove Column -->
          <ng-container matColumnDef="add">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <!--<div *ngIf="!containIngr(element); else elseTemplate">-->
              <div *ngIf="!containIngr(element); else elseTemplate">
                <i  aria-hidden="true" class="far fa-plus-square btnIngr fa-2x" (click)="addIngredient(element)" matTooltip="{{ 'contretypage.addOneIngr' | translate}}"></i>
              </div>
              <ng-template #elseTemplate>
                <div>
                  <i  aria-hidden="true" class="fas fa-minus-square btnIngr fa-2x" (click)="deleteIngredient(element)"></i>
                </div>
              </ng-template>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumnsIngredient; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumnsIngredient;"></mat-row>
        </mat-table>
      </div>
      <div class="center">
        <button class="btn btn-secondary btnValid button" type="button" label="Annuler" name="Annuler" value="Annuler" (click)="closeModal('ModalIngredient')">Fermer</button>
      </div>
    </div>
  </div>
</div>

<div id="ModalNextMultiCouche" class="modal">
  <div class="modal-content-NextMultiCouche">
    <span class="text-right mr-2 pointe closer" (click)="closeModal('ModalNextMultiCouche');">  <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
    <div class="container">
      <div class="upperText">
        <h2 class="text-center">{{'contretypage.envoiReponse'|translate}}</h2> <!--{idContretypage}}</h2>-->
      </div>
      <div class="center">
        <button class="btn btn-secondary modal-content-confirm-cancel" type="button" name="Valider" value="Valider" (click)="closeModal('ModalNextMultiCouche')">
          <span [translate]="'contretypage.confirmer'"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<div id="ModalQrCode" class="modal noPrint">
  <div class="modal-content-QrCode col-10 col-md-4">
    <div class="centerqr">
      <img class="thumbnail zoomQrCode-img" src="data:image/png;base64,{{zoomQrcode}}" alt=""/>
    </div>
    <button class="mx-auto close-modal-content-QrCode" (click)="closeModal('ModalQrCode')">{{'activlist.fermer'|translate}}</button>
  </div>
</div>

<div class="toPrint">

  <div class="headerPrint">
    <img class="enteteImp" src="assets/Impression/entetePrint.png" alt=""/>
    <h2 class="enteteContent">{{ 'contretypage.stepColorMatching' | translate}}</h2>
    <img class="imgImp" src="assets/Impression/peintre.png" alt=""/>
    <div class="accroche"> {{ 'contretypage.accrocheImp' | translate}} </div>
  </div>

  <div class="contentPrint">
    <div class="infoContretypage legendImp">
      <div>{{ 'contretypage.demande' | translate}} : {{colorMatching.reference}}</div>
      <div>
        {{ 'common.manufacturer' | translate}} :
        <span *ngIf="colorMatching.response != undefined; then showBrandRep else showBrandReq"></span>
        <ng-template #showBrandRep>{{ colorMatching.response.brandVehicle }}</ng-template>
        <ng-template #showBrandReq>{{ colorMatching.brandVehicle }}</ng-template>
      </div>
      <div>
        {{ 'details.code' | translate}} :
        <span *ngIf="colorMatching.response != undefined; then showCodeRep else showCodeReq"></span>
        <ng-template #showCodeRep>{{ colorMatching.response.codeFormule }}</ng-template>
        <ng-template #showCodeReq>{{ colorMatching.codePainting }}</ng-template>
      </div>
      <div>
        {{ 'common.designation' | translate}} :
        <span *ngIf="colorMatching.response != undefined; then showDesFormRep else showDesFormReq"></span>
        <ng-template #showDesFormRep>{{ colorMatching.response.designationPainting }}</ng-template>
        <ng-template #showDesFormReq>{{ colorMatching.designationPainting }}</ng-template>
      </div>
      <div>
        {{ 'contretypage.variante' | translate}} :
        <span *ngIf="colorMatching.response != undefined; then showVarFormRep else notShow"></span>
        <ng-template #showVarFormRep>{{ colorMatching.response.variante }}</ng-template>
      </div>
      <div>
        {{ 'monitoring.date' | translate}} :
        <span *ngIf="colorMatching.response != undefined && compareDate(colorMatching.dateFinish); then showDateImp else notShow"></span>
        <ng-template #showDateImp> {{ colorMatching.dateFinish | date:"dd/MM/yyyy" }}</ng-template>
      </div>
      <p>
        {{ 'common.technology' | translate}} :


        <ng-container *ngIf="responseCM != undefined; else secondTechImp"> {{ Technologie[this.paintQuality] }} (0) </ng-container>
        <ng-template #secondTechImp>
          <ng-container *ngIf="techDemande != undefined;else notShow">{{ techDemande }} (0)</ng-container>
        </ng-template>

        <!--<span *ngIf="responseCM != undefined; then showTechnoImp else notShow"> {{ techDemande }} (0)</span>Z
        <ng-template #showTechnoImp> {{ Technologie[this.paintQuality] }} (0)</ng-template>-->
      </p>
    </div>
    <div *ngIf="colorMatching.response != undefined" class="qrCodeContretypage">
      <div>
        <img class="thumbnail" src="data:image/png;base64,{{qrcode}}" alt=""/>
      </div>
    </div>
    <div *ngIf="colorMatching.response != undefined" class="legendImp">

      <div class="breakPage">
        {{ 'contretypage.ingrForm' | translate}} (0) :
        <table class="table lstIngrCM table-responsive">
          <caption></caption>
          <thead>
            <tr>
              <th scope="col">{{ 'contretypage.numero' | translate}}</th>
              <th scope="col">{{ 'details.code' | translate}}</th>
              <th scope="col">{{ 'common.designation' | translate}} </th>
              <th scope="col">{{ 'contretypage.qte' | translate}}</th>
              <th scope="col">{{ 'contretypage.cumul' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of colorMatching.response.ingredients">
              <td>{{ element.position }}</td>
              <td>{{ element.code }}</td>
              <td>{{ element.name }}</td>
              <td>{{ element.quantity }}</td>
              <td>{{ element.qtyCumule }}</td>
            </tr>
          </tbody>

        </table>
      </div>

      <div *ngIf="colorMatching.response != undefined && colorMatching.response.responseMulti != undefined">
        <div *ngFor="let multi of colorMatching.response.responseMulti; let index = index;" class="breakPageAlways">

          <div class="infoContretypage legendImp">
            <div>{{ 'contretypage.demande' | translate}} : {{colorMatching.reference}}</div>
            <div>
              {{ 'common.manufacturer' | translate}} :
              <span *ngIf="colorMatching.response != undefined; then showBrandRep else showBrandReq"></span>
              <ng-template #showBrandRep>{{ colorMatching.response.brandVehicle }}</ng-template>
              <ng-template #showBrandReq>{{ colorMatching.brandVehicle }}</ng-template>
            </div>
            <div>
              {{ 'details.code' | translate}} :
              <span *ngIf="colorMatching.response != undefined; then showCodeRep else showCodeReq"></span>
              <ng-template #showCodeRep>{{ colorMatching.response.codeFormule }}</ng-template>
              <ng-template #showCodeReq>{{ colorMatching.codePainting }}</ng-template>
            </div>
            <div>
              {{ 'common.designation' | translate}} :
              <span *ngIf="colorMatching.response != undefined; then showDesFormRep else showDesFormReq"></span>
              <ng-template #showDesFormRep>{{ colorMatching.response.designationPainting }}</ng-template>
              <ng-template #showDesFormReq>{{ colorMatching.designationPainting }}</ng-template>
            </div>
            <div>
              {{ 'contretypage.variante' | translate}} :
              <span *ngIf="colorMatching.response != undefined; then showVarFormRep else notShow"></span>
              <ng-template #showVarFormRep>{{ colorMatching.response.variante }}</ng-template>
            </div>
            <div>
              {{ 'monitoring.date' | translate}} :
              <span *ngIf="colorMatching.response != undefined && compareDate(colorMatching.dateFinish); then showDateImp else notShow"></span>
              <ng-template #showDateImp> {{ colorMatching.dateFinish | date:"dd/MM/yyyy" }}</ng-template>
            </div>
            <p>
              {{ 'common.technology' | translate}} :


              <ng-container *ngIf="responseCM != undefined; else secondTechImp"> {{ Technologie[this.paintQuality] }} ({{index + 1}}) </ng-container>
              <ng-template #secondTechImp>
                <ng-container *ngIf="techDemande != undefined;else notShow">{{ techDemande }} ({{index + 1}})</ng-container>
              </ng-template>


              <!--<span *ngIf="responseCM != undefined; then showTechnoImp else notShow">{{ techDemande }} (0)</span>
              <ng-template #showTechnoImp> {{ Technologie[this.paintQuality] }} ({{index + 1}})</ng-template>-->

            </p>
          </div>


          <div id="qrCodeContretypage-{{index}}" class="qrCodeContretypage">

          </div>

          <div class="infoContretypage vertical-align-bottom">
            {{ 'contretypage.ingrForm' | translate}} ({{ index + 1 }}) :
          </div>

          <table class="table lstIngrCM table-responsive">
            <caption></caption>
            <thead>
              <tr>
                <th scope="col">{{ 'contretypage.numero' | translate}}</th>
                <th scope="col">{{ 'details.code' | translate}}</th>
                <th scope="col">{{ 'common.designation' | translate}} </th>
                <th scope="col">{{ 'contretypage.qte' | translate}}</th>
                <th scope="col">{{ 'contretypage.cumul' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of multi.ingredients">
                <td>{{ element.position }}</td>
                <td>{{ element.code }}</td>
                <td>{{ element.name }}</td>
                <td>{{ element.quantity }}</td>
                <td>{{ element.qtyCumule }}</td>
              </tr>
            </tbody>

          </table>

        </div>
      </div>

      <div class="ecartElement">
        {{ 'contretypage.ecart' | translate}} : {{ colorMatching.response.legend }}
      </div>
      <!--<div class="flexRow">-->
      <div class="">
        {{ 'contretypage.comment' | translate}} : {{ colorMatching.response.comment }}
      </div>
      <div class="">
        {{ 'contretypage.infoForm' | translate}} :

        <ul class="sentencesImp">
          <li *ngFor="let textSentence of textSentencesCM">
            {{ textSentence.text }}
          </li>
        </ul>

      </div>
      <!--</div>-->
      <div class="legendImp">
        <br />
        <div>{{ 'contretypage.legend' | translate}} :</div>
        <div>
          {{ 'contretypage.leg1' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg2' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg3' | translate}}
        </div>
        <div>
          {{ 'contretypage.leg4' | translate}}
        </div>
        <div>
          {{ 'contretypage.etoile1' | translate}}
        </div>
        <div>
          {{ 'contretypage.etoile2' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
